import React from 'react';
import { useTranslation } from 'react-i18next';

import useStyles from './styles';
import { AppHeader } from 'components';
import { Typography } from '@material-ui/core';

const PayPalInstruction = () => {
  const classes = useStyles();
  const [t] = useTranslation();

  return (
    <>
      <AppHeader />
      <div className={classes.root}>
        <div className={classes.container}>
          <Typography variant="h1" className={classes.title}>
            {t('How to add PayPal to your website')}
          </Typography>
          <Typography variant="body1" className={classes.paragraph}>
            {t('Prior to configuring the PayPal Payment')}
          </Typography>
          <Typography variant="body1">
            <ol>
              <li className={classes.listItem}>{t('Go to https')}</li>
              <li className={classes.listItem}>
                {t(
                  'Navigate to the My Apps & Credentials tab and click the CREATE APP button in the REST API Apps section.'
                )}
              </li>
              <li className={classes.listItem}>
                {t(
                  'Name the application (this does not impact the integration).'
                )}
              </li>
              <li className={classes.listItem}>
                {t(
                  'Select “Live” and fill in your PayPal account credentials.'
                )}
              </li>
              <li className={classes.listItem}>
                {t('Click the CREATE APP button.')}
              </li>
              <li className={classes.listItem}>
                {t(
                  'The App will be created and you can copy the Client ID and Client Secret from this page.'
                )}
              </li>
              <li className={classes.listItem}>
                {t(
                  'Go to the Horn Admin Portal and select Settings on the horizontal navigation bar.'
                )}
              </li>
              <li className={classes.listItem}>
                {t(
                  'On the Payment Settings page add the new panel and select “PayPal” in the drop-down.'
                )}
              </li>
              <li className={classes.listItem}>
                {t(
                  'Paste copied Client ID and Client Secret values into appropriate fields and Save the page.'
                )}
              </li>
            </ol>
          </Typography>
        </div>
      </div>
    </>
  );
};

export default PayPalInstruction;
